import jQuery from "jquery";
import {GOOGLE_MAPS_API_KEY} from '../constants/constants';
let $ = window.$ = window.jQuery = jQuery;

const getEstadoByLocation = (position, regiones) => {
    let lat = position.coords.latitude;
    let lng = position.coords.longitude;
    let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`;

    return fetch(url)
        .then(result => result.json())
        .then(json => {
            let result = json.results;
            let estadoResult = regiones[0].estados[0];
            let pais = undefined;
            for(let i = 0; i < result.length; i++){
                let r = result[i];
                if (r.types[0] === 'administrative_area_level_1') {
                    estadoResult = r.address_components[0].long_name;
                    continue;
                }
                if(r.types[0] === 'country'){
                    pais = r.address_components[0].long_name;
                }
            }
            if(pais === "Venezuela") {
                return estadoResult;
            }
            return regiones[0].estados[0];
        })
        .catch(e => regiones[0].estados[0]);
};

export const getCurrentEstado = (regiones) => {
    return new Promise((resolve, reject) => {
        let latLng = false;
        let geoOptions = {timeout: 5000};
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                latLng = true;
                resolve(getEstadoByLocation(position, regiones));
            }, () => {
                latLng = true;
                reject(regiones[0].estados[0]);
            }, geoOptions);
        } else {
            latLng = true;
            resolve(regiones[0].estados[0]);
        }

        setTimeout(() => {
            if(!latLng){
                reject(regiones[0].estados[0]);
            }
        }, geoOptions.timeout + 1000);
    });
};

export const loadScript = (url) => {
    return new Promise((resolve,reject) => {
        let script = document.createElement('script');
        script.src = url;
        script.addEventListener('load', () => {
            resolve();
        });
        script.addEventListener('error', () => {
            reject();
        });
        document.body.appendChild(script);
    });
};

export const hideHeader = () => {
    $("#header").find(".ocultable").hide("fast");
    $("#form-buscar-header").show("fast");
};

export const showHeader = () => {
    $("#header").find(".ocultable").show("fast");
    $("#form-buscar-header").hide("fast");
};

export const routeChanged = (location) => {
    if(!location.startsWith("/region")) {
        window.scrollTo(0, 0);
    }
};


// WEBPACK FOOTER //
// ./src/constants/functions.js